module.exports = __webpack_public_path__ + "media/images/emblems/Daeniken-blason-456cd83a4ac32b0ff81a30c8d9681112.png";